(function () {
  var banner = document.querySelector('.voucher-banner');
  if (!banner) return;

  // 첫 hero 진입 구간에서는 fixed 배너를 숨겨 hero 상단을 가리지 않는다.
  // 이후에도 내려갈 때는 숨김을 유지하고, 올릴 때만 노출한다.
  var HERO_SAFE_ZONE_RATIO = 0.3;
  var HERO_SAFE_ZONE_MIN = 160;
  var HERO_SAFE_ZONE_MAX = 240;
  var DIRECTION_TOLERANCE = 16;
  var TOGGLE_COOLDOWN_MS = 200;
  var HIDDEN = 'is-hidden';
  var MIX = 'voucher-banner--mix';
  var MIX_THRESHOLD_HOURS = 5;
  var lastY = window.pageYOffset;
  var lastToggleAt = 0;
  var ticking = false;

  function getHeroSafeZone() {
    return Math.round(
      Math.min(
        Math.max(window.innerHeight * HERO_SAFE_ZONE_RATIO, HERO_SAFE_ZONE_MIN),
        HERO_SAFE_ZONE_MAX
      )
    );
  }

  function setHidden(hidden, force) {
    if (banner.classList.contains(HIDDEN) === hidden) return;
    if (!force && performance.now() - lastToggleAt < TOGGLE_COOLDOWN_MS) return;

    banner.classList.toggle(HIDDEN, hidden);
    lastToggleAt = performance.now();
  }

  function updateScroll() {
    ticking = false;
    var y = window.pageYOffset;
    var maxY = document.documentElement.scrollHeight - window.innerHeight;
    if (y < 0 || y > maxY) return;

    var inHeroSafeZone = y <= getHeroSafeZone();

    if (inHeroSafeZone) {
      setHidden(true, true);
      lastY = y;
      return;
    }

    var diff = y - lastY;
    if (Math.abs(diff) < DIRECTION_TOLERANCE) return;
    lastY = y;

    setHidden(diff > 0, false);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateScroll);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateScroll();

  var stockEl = banner.querySelector('[data-stock-count]');
  var MS_PER_HOUR = 60 * 60 * 1000;
  var UPDATE_INTERVAL_MS = 60 * 1000;

  function readIntAttr(name, fallback) {
    var value = parseInt(banner.getAttribute(name) || '', 10);
    return isNaN(value) ? fallback : value;
  }

  var stockMax = readIntAttr('data-stock-max', 50);
  var stockMin = readIntAttr('data-stock-min', 2);
  var stockPerHour = readIntAttr('data-stock-per-hour', 2);
  var cycleHours = readIntAttr('data-cycle-hours', 24);
  if (stockMax <= 0) stockMax = 50;
  if (stockMin < 0) stockMin = 2;
  if (stockPerHour <= 0) stockPerHour = 2;
  if (cycleHours <= 0) cycleHours = 24;

  var cycleMs = cycleHours * MS_PER_HOUR;
  var startedAtStr = (banner.getAttribute('data-started-at') || '').trim();
  var startedAtTs = new Date(startedAtStr).getTime();
  if (isNaN(startedAtTs)) startedAtTs = Date.now();

  function getCurrentCycle(now) {
    var cyclesElapsed = Math.max(0, Math.floor((now - startedAtTs) / cycleMs));
    var startTs = startedAtTs + cyclesElapsed * cycleMs;
    return {
      startTs: startTs,
      endTs: startTs + cycleMs,
    };
  }

  function calculateStock(now, startTs) {
    var elapsedHours = Math.floor(Math.max(0, now - startTs) / MS_PER_HOUR);
    return Math.max(stockMin, stockMax - elapsedHours * stockPerHour);
  }

  function updateBanner() {
    var now = Date.now();
    var cycle = getCurrentCycle(now);
    var diff = Math.max(0, cycle.endTs - now);
    banner.classList.toggle(MIX, diff <= MIX_THRESHOLD_HOURS * MS_PER_HOUR);
    if (stockEl) stockEl.textContent = calculateStock(now, cycle.startTs);
  }

  updateBanner();
  setInterval(updateBanner, UPDATE_INTERVAL_MS);
})();
